import script from "./CardHabitacion.vue?vue&type=script&setup=true&lang=js"
export * from "./CardHabitacion.vue?vue&type=script&setup=true&lang=js"

import "./CardHabitacion.vue?vue&type=style&index=0&id=1e044c08&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e044c08"]])

export default __exports__